import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { Button, CancelCrossIcon, Dialog, Header3, Table, Tbody, Thead } from "@activecollab/components";
import * as PropTypes from "prop-types";
import FormatDate from "~/components/Formatters/FormatDate";
import { getAllInvoicesSorted } from "~/store/selectors/selector.subscription";
import { currencySymbols } from "~/utils/currency_symbols.jsx";

const ListOfAllInvoices = ({ open, onClose }) => {
  const invoices = useSelector(getAllInvoicesSorted);

  const onCloseClick = useCallback(() => {
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <Dialog.Title
        disableDefaultHeading
        className="tw-flex tw-justify-between tw-items-center"
      >
        <Header3>Billing History</Header3>
        <Button
          variant="text gray"
          onClick={onCloseClick}
        >
          <CancelCrossIcon />
        </Button>
      </Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content>
        <Table
          striped
          wrapperClassName="tw-m-0"
        >
          <Thead headerVariant="secondary">
            <tr>
              <th className="tw-w-28 tw-px-4 tw-text-left">Date</th>
              <th className="tw-w-36 tw-px-4 tw-text-right">Amount</th>
              <th className="tw-w-52 tw-pr-6 tw-text-right">Action</th>
            </tr>
          </Thead>
          <Tbody>
            {invoices.map((invoice) => {
              return (
                <tr key={invoice.id}>
                  <td className="tw-w-28 tw-py-2">
                    <FormatDate value={invoice.issued_on} />
                  </td>
                  <td className="tw-w-36 tw-py-2 tw-text-right">
                    {currencySymbols[invoice.currency_code]}
                    {invoice.amount}
                  </td>
                  <td className="tw-w-52 tw-py-2 tw-text-right">
                    <a
                      href={invoice.download_url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button variant="tertiary">View invoice</Button>
                    </a>
                  </td>
                </tr>
              );
            })}
          </Tbody>
        </Table>
      </Dialog.Content>
    </Dialog>
  );
};

ListOfAllInvoices.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ListOfAllInvoices;
